import PageHeading from "component/ui/PageHeading";
import SearchInput from "component/ui/SearchInput";
import TabSwitcher from "component/ui/Tabs";
import { useState, useEffect, useRef } from "react";
import { FiSearch } from "react-icons/fi";
import ChatModal from "./chatModal";

import {
  collection,
  query,
  where,
  onSnapshot,
  orderBy,
  doc,
  updateDoc,
  serverTimestamp,
} from "firebase/firestore";
import { db } from "../../firebaseConfig";
import { CHAT_TYPES, delay } from "helper/constant";
import { formatChatTime } from "helper/appConstant";
import ChatScreen from "pages/community/ChatScreen";
import { useScreenType } from "component/common/screenType";
import Button from "component/ui/Button";
import { useDispatch, useSelector } from "react-redux";
import { getAcceptConnectionList } from "store/slice/profile";
import Input from "component/ui/Input";
import { toast } from "react-toastify";
import { createGroup } from "store/slice/booking";
import { FaPen } from "react-icons/fa";
import { userImageUpload } from "store/slice/auth";
import { useLoginData } from "component/common/loginData";
import { useNavigate, useSearchParams } from "react-router-dom";

const Messages = () => {
  const [activeTab, setActiveTab] = useState("cards");
  const [messageData, setMessageData] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedChat, setSelectedChat] = useState(false);
  const screenType = useScreenType();
  const dispatch = useDispatch();
  const userData = useLoginData();
  const fileInputRef = useRef(null);
  const { connectionListData } = useSelector((state) => state.profile);
  const [groupName, setGroupName] = useState("");
  const [connectList, setConnectionList] = useState([]);
  const [activeChatData, setActiveChatData] = useState(null);
  const [messages, setMessages] = useState([]);
  const [isGroupEdit, setIsGroupEdit] = useState(false);
  const CURRENT_USER_ID = userData?.id; //  auth user id
  const [group, setGroup] = useState(false);
  const [groupProfileImage, setGroupProfileImage] = useState(null);
  const [searchParams] = useSearchParams();
  const type = searchParams.get("type");
  const UID = searchParams.get("id");
  const navigate = useNavigate();
  // set tab by type and id
  // set tab by type
  useEffect(() => {
    if (type) {
      setActiveTab(type);
    }
  }, [type, UID]);
  /* ----------------------------------
     FETCH CHAT LIST (REALTIME)
     ---------------------------------- */
  useEffect(() => {
    const q = query(
      collection(db, process.env.REACT_APP_DB_NAME),
      where("type", "==", activeTab),
      where("participants", "array-contains", CURRENT_USER_ID),
      orderBy("updatedAt", "desc")
    );

    const unsubscribe = onSnapshot(q, (snapshot) => {
      const chats = snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      setMessageData(chats);
    });

    return () => unsubscribe();
  }, [activeTab]);
  /* ----------------------------------
     get connection list
     ---------------------------------- */
  useEffect(() => {
    dispatch(getAcceptConnectionList(1, 100));
  }, []);

  useEffect(() => {
    if (connectionListData) {
      setConnectionList(JSON.parse(JSON.stringify(connectionListData?.data)));
    }
  }, [connectionListData]);

  /* ----------------------------------
     SEARCH FILTER
     ---------------------------------- */
  const filteredData = messageData.filter(
    (item) =>
      item.refID?.toLowerCase().includes(searchQuery.toLowerCase()) ||
      item.msg?.toLowerCase().includes(searchQuery.toLowerCase())
  );

  /* ----------------------------------
     DATE LABEL
     ---------------------------------- */
  const getDateLabel = (dateStr) => {
    const today = new Date();
    const date = new Date(dateStr);

    const diff =
      (today.setHours(0, 0, 0, 0) - date.setHours(0, 0, 0, 0)) /
      (1000 * 60 * 60 * 24);

    if (diff === 0) return "Today";
    if (diff === 1) return "Yesterday";

    return date.toLocaleDateString("en-IN", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  };

  /* ----------------------------------
     TABS
     ---------------------------------- */
  const MessagesMenu = [
    {
      id: 1,
      title: "Cards",
      border: activeTab === CHAT_TYPES?.CARDS,
      onClick: () => {
        if (type) {
          navigate("/messages");
        }
        setActiveTab(CHAT_TYPES?.CARDS);
      },
    },
    {
      id: 2,
      title: "Connections",
      border: activeTab === CHAT_TYPES?.CONNECTIONS,
      onClick: () => {
        if (type) {
          navigate("/messages");
        }
        setActiveTab(CHAT_TYPES?.CONNECTIONS);
      },
    },
    {
      id: 3,
      title: "Groups",
      border: activeTab === CHAT_TYPES?.GROUPS,
      onClick: () => {
        if (type) {
          navigate("/messages");
        }
        setActiveTab(CHAT_TYPES?.GROUPS);
      },
    },
    // {
    //   id: 4,
    //   title: "Marketplace",
    //   border: activeTab === CHAT_TYPES?.MARKETPLACE,
    //   onClick: () => setActiveTab(CHAT_TYPES?.MARKETPLACE),
    // },
  ];
  /* ----------------------------------
     Reset chat unread counts
     ---------------------------------- */
  const resetUnreadCount = async (chatId, userId) => {
    const chatRef = doc(db, process.env.REACT_APP_DB_NAME, chatId);
    await updateDoc(chatRef, {
      [`unreadCounts.${CURRENT_USER_ID}`]: 0,
    });
  };
  /* ----------------------------------
    FETCH CHAT DATA 
     ---------------------------------- */
  const handleOpenChat = async (data) => {
    setActiveChatData(data);
    const messagesRef = collection(
      db,
      process.env.REACT_APP_DB_NAME,
      data?.id,
      "messages"
    );
    // Reset unread count for current user
    await resetUnreadCount(data?.id, CURRENT_USER_ID);
    const q = query(messagesRef, orderBy("createdAt", "asc")); // ascending order

    const unsubscribe = onSnapshot(q, (snapshot) => {
      const msgs = snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      if (msgs?.length > 0) {
        setMessages(msgs);
      }
    });
    if (screenType != "desktop") {
      setSelectedChat(true);
    }
  };
  // open chat by default first chat
  useEffect(() => {
    if (screenType == "desktop" && filteredData?.length > 0) {
      if (filteredData[0]?.type != activeChatData?.type) {
        if (UID) {
          const chat = filteredData.find((c) => c.participants.includes(UID));
          setActiveChatData(chat);
        } else {
          setActiveChatData(filteredData[0]);
        }
      }
    }
  }, [activeTab, filteredData]);

  // get user info by id
  const handleGetInfo = (item, key) => {
    const otherUserId = item?.participants?.find(
      (id) => id !== CURRENT_USER_ID
    );
    return item?.usersInfo[otherUserId][key];
  };
  const closeGroupCreateDialog = () => {
    setConnectionList(connectionListData?.data);
    setGroup(false);
    setGroupName("");
  };
  // handle create group
  const handleCreateGroup = () => {
    if (!groupName) {
      return toast.error("please enter group name");
    }
    if (!connectList?.some((item) => item?.isSelected)) {
      return toast.error("please add members");
    }
    const request = {
      language: "en",
      groupName: groupName,
      groupMembers: connectList
        ?.filter((item) => item?.isSelected)
        ?.map((item) => item?.sId),
      groupId: null,
    };
    dispatch(createGroup(request, closeGroupCreateDialog));
  };

  const handleOpenEditChat = () => {
    setIsGroupEdit(true);
    setGroupName(activeChatData?.groupName);
    setGroupProfileImage(activeChatData?.groupProfileImage);
    const updatedList = connectList.map((item) => ({
      ...item,
      isSelected: activeChatData?.participants?.includes(item?.sId),
    }));

    setConnectionList(updatedList);
    setGroup(true);
  };
  //  update edit data
  useEffect(() => {
    if (isGroupEdit) {
      const data = filteredData?.find((item) => item?.id == activeChatData?.id);
      setActiveChatData(data);
    }
  }, [filteredData]);
  // update group details
  const handleUpdateGroup = async () => {
    const chatRef = doc(db, process.env.REACT_APP_DB_NAME, activeChatData?.id);
    let participants = [
      ...connectList
        ?.filter((item) => item?.isSelected)
        ?.map((item) => item?.sId),
      CURRENT_USER_ID,
    ];
    let usersInfo = { [CURRENT_USER_ID]: userData };
    const selectedUser = connectList?.filter((item) => item?.isSelected);
    selectedUser?.map((user) => {
      if (user?.isSelected) {
        usersInfo = { ...usersInfo, [user?.sId]: user };
      }
    });
    const request = {
      groupName: groupName,
      participants: participants,
      usersInfo: usersInfo,
      updatedAt: serverTimestamp(),
      groupProfileImage: groupProfileImage,
    };
    await updateDoc(chatRef, request);
    setGroup(false);
    // ⏳ wait for 3 seconds
    await delay(3000);
    setIsGroupEdit(false);
  };

  // hanlde group profile image upload
  const handleFileSelect = async (event) => {
    const file = event.target.files;
    if (!file) return;
    const formData = new FormData();
    if (typeof file === "object" && file !== null) {
      Object.entries(file).forEach(([key, value]) => {
        formData.append("file", value);
      });
    }
    try {
      // Dispatch the upload action
      const data = await dispatch(
        userImageUpload(formData, "chatMedia", "image")
      );
      if (data?.length > 0) {
        setGroupProfileImage(data[0]?.path);
      }
    } catch (error) {
      console.error("Error uploading files:", error);
    }
  };

  // // handle search filter
  // const handleSearch = (value) => {
  //   filteredData = messageData.filter(
  //     (item) =>
  //       item.refID?.toLowerCase().includes(searchQuery.toLowerCase()) ||
  //       item.msg?.toLowerCase().includes(searchQuery.toLowerCase())
  //   );
  // };
  return (
    <div className="min-h-screen bg-gray-100 p-4 md:p-6">
      <div className="container mx-auto max-w-7xl">
        <PageHeading title="Messages" />
        <div className="rounded-xl shadow bg-white border border-gray-200 mt-5">
          <TabSwitcher tabs={MessagesMenu} />

          <div className="">
            {activeTab == CHAT_TYPES?.GROUPS && filteredData?.length <= 0 && (
              <div className="p-2 flex justify-end">
                <Button
                  onClick={() => {
                    setGroup(true);
                    setIsGroupEdit(false);
                  }}
                  children={"Create Group"}
                />{" "}
              </div>
            )}
            {filteredData?.length > 0 ? (
              <div className="grid grid-cols-1 lg:grid-cols-3 border-2 rounded-lg min-h-[80vh] max-h-[80vh] m-5">
                <div className="">
                  {/* <div className="my-2">
                    <SearchInput
                      value={searchQuery}
                      onChange={(e) => {
                        setSearchQuery(e.target.value);
                        handleSearch(e.target.value);
                      }}
                      placeholder="Search conversation"
                      icon={FiSearch}
                    />
                  </div> */}
                  {activeTab == CHAT_TYPES?.GROUPS && (
                    <div className="p-2 flex justify-end">
                      <Button
                        onClick={() => {
                          setGroup(true);
                          setIsGroupEdit(false);
                        }}
                        children={"Create Group"}
                      />{" "}
                    </div>
                  )}
                  {filteredData?.map((item) => (
                    <div key={item?.id}>
                      <div
                        key={item.id}
                        style={{
                          background:
                            item?.id == activeChatData?.id ? "#2bace247" : "",
                        }}
                        onClick={() => handleOpenChat(item)}
                        className="p-4 relative  bg-gray-50 border hover:shadow transition cursor-pointer"
                      >
                        <div className="flex items-center space-x-3">
                          {/* cards profile */}
                          {item?.type == CHAT_TYPES?.CARDS && (
                            <div className="rounded-full bg-gray-200 p-3 w-fit">
                              {item?.sportIcon}
                            </div>
                          )}
                          {/* connection profile */}
                          {item?.type == CHAT_TYPES?.CONNECTIONS && (
                            <div
                              style={
                                handleGetInfo(item, "profileImageUrl")
                                  ? {
                                      backgroundImage: `url(${handleGetInfo(
                                        item,
                                        "profileImageUrl"
                                      )})`,
                                      backgroundSize: "cover",
                                      backgroundPosition: "center",
                                      backgroundRepeat: "no-repeat",
                                    }
                                  : {
                                      backgroundColor:
                                        item?.id == activeChatData?.id
                                          ? "white"
                                          : "#2bace2",
                                      color:
                                        item?.id == activeChatData?.id
                                          ? "#2bace2"
                                          : "white",
                                    }
                              }
                              className="rounded-full w-10 h-10 text-white font-semibold flex justify-center items-center"
                            >
                              {!handleGetInfo(item, "profileImageUrl") &&
                                handleGetInfo(item, "name") &&
                                handleGetInfo(item, "name")
                                  ?.charAt(0)
                                  ?.toUpperCase()}
                            </div>
                          )}
                          {/* group profile */}
                          {item?.type == CHAT_TYPES?.GROUPS && (
                            <div
                              style={
                                item?.groupProfileImage
                                  ? {
                                      backgroundImage: `url(${item.groupProfileImage})`,
                                      backgroundSize: "cover",
                                      backgroundPosition: "center",
                                      backgroundRepeat: "no-repeat",
                                    }
                                  : {
                                      backgroundColor:
                                        item?.id == activeChatData?.id
                                          ? "white"
                                          : "#2bace2",
                                      color:
                                        item?.id == activeChatData?.id
                                          ? "#2bace2"
                                          : "white",
                                    }
                              }
                              className="rounded-full w-10 h-10 text-white font-semibold flex justify-center items-center"
                            >
                              {item?.groupProfileImage
                                ? ""
                                : item?.groupName &&
                                  item?.groupName?.charAt(0)?.toUpperCase()}
                            </div>
                          )}
                          <div className="w-full">
                            <h4 className="font-medium text-gray-800">
                              {item?.type == CHAT_TYPES?.GROUPS
                                ? item?.groupName
                                : item?.type == CHAT_TYPES?.CONNECTIONS
                                ? handleGetInfo(item, "name")
                                : item?.refID}
                            </h4>
                            <p className="text-sm text-gray-500">
                              {item?.sportName}
                            </p>
                            <div className="flex items-center justify-between mt-1 ">
                              <p className="text-sm text-gray-700">
                                {item?.lastMessage}{" "}
                                {item?.unreadCounts?.[CURRENT_USER_ID] > 0 && (
                                  <span className="text-xs text-white bg-highlight px-2 rounded-full">
                                    {item?.unreadCounts[CURRENT_USER_ID]}
                                  </span>
                                )}
                              </p>
                              <p className="text-xs text-gray-600">
                                {formatChatTime(item?.lastMessageDate)}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
                {/* chat screen for desktop view */}
                {screenType == "desktop" && (
                  <div className="col-span-2">
                    <ChatScreen
                      handleGetInfo={handleGetInfo}
                      data={messages}
                      handleOpenEditChat={handleOpenEditChat}
                      filteredData={filteredData}
                      setActiveChatData={setActiveChatData}
                      setMessages={setMessages}
                      activeChatData={activeChatData}
                    />
                  </div>
                )}
              </div>
            ) : (
              <div className="h-[80vh] flex items-center justify-center">
                <p className="text-center text-sm text-gray-500">
                  No conversations found
                </p>
              </div>
            )}
          </div>
        </div>
      </div>
      {/* chat screen for mobile view */}
      {selectedChat && screenType != "desktop" && (
        <ChatModal
          isOpen={selectedChat}
          data={messages}
          handleGetInfo={handleGetInfo}
          setMessages={setMessages}
          activeChatData={activeChatData}
          filteredData={filteredData}
          setActiveChatData={setActiveChatData}
          onClose={() => {
            setSelectedChat(false);
            setActiveChatData(null);
          }}
        />
      )}

      {/* add/update group model  */}
      {group && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
          <div className="bg-white p-6 rounded-lg shadow-xl w-96">
            <h2 className="text-xl font-medium mb-2">Create New Group</h2>
            <input
              type="file"
              accept="image/*"
              ref={fileInputRef}
              onChange={handleFileSelect}
              className="hidden"
            />
            {isGroupEdit && (
              <div className="flex justify-center my-3">
                <div
                  style={{
                    backgroundImage: groupProfileImage
                      ? `url("${groupProfileImage}")`
                      : "",
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    backgroundRepeat: "no-repeat",
                  }}
                  className="relative h-24 w-24 flex justify-center items-center bg-highlight rounded-full"
                >
                  {!groupProfileImage &&
                    groupName &&
                    groupName?.charAt(0)?.toUpperCase()}
                  <div
                    onClick={() => fileInputRef.current.click()}
                    className="absolute flex cursor-pointer justify-center items-center h-6 w-6 bg-black rounded-full bottom-2 right-0"
                  >
                    <FaPen className="h-3 w-3" color="#2bace2" />
                  </div>
                </div>{" "}
              </div>
            )}

            <Input
              value={groupName}
              onChange={(value) => setGroupName(value)}
              placeholder={"Enter Group Name"}
            />
            <p className="text-sm text-gray-500 mb-1 mt-4">
              Select members to add to your group
            </p>

            {/* User List Container - max-h keeps the modal from growing too big */}
            <div className="space-y-3 max-h-64 overflow-y-auto thin-scrollbar mb-6 pr-2">
              {connectList?.map((user, index) => (
                <div
                  key={user?.sId}
                  className="flex items-center justify-between p-2 hover:bg-gray-50 rounded-md transition-colors"
                >
                  <div className="flex items-center gap-3">
                    {user?.profileImageUrl ? (
                      <img
                        src={user?.profileImageUrl}
                        alt={user.name}
                        className="w-10 h-10 rounded-full object-cover border border-gray-200"
                      />
                    ) : (
                      <div className="w-10 h-10 rounded-full text-white font-semibold bg-highlight flex justify-center items-center">
                        {user?.name && user?.name?.charAt(0)?.toUpperCase()}
                      </div>
                    )}
                    <span className="text-sm font-medium text-gray-700">
                      {user?.name}
                      <br />
                      <p className="text-xs text-gray-400"> {user?.email}</p>
                    </span>
                  </div>

                  <input
                    onClick={(e) => {
                      setConnectionList((prev) =>
                        prev.map((item, i) =>
                          i === index
                            ? { ...item, isSelected: e.target.checked }
                            : item
                        )
                      );
                    }}
                    checked={user?.isSelected}
                    type="checkbox"
                    className="w-4 h-4 rounded border-gray-300 text-blue-600 focus:ring-blue-500"
                  />
                </div>
              ))}
            </div>

            {/* Action Buttons */}
            <div className="flex justify-end gap-3 pt-4 border-t border-gray-100">
              <Button
                fullWidth
                variant="secondary"
                onClick={closeGroupCreateDialog}
              >
                Cancel
              </Button>
              <Button
                fullWidth
                onClick={isGroupEdit ? handleUpdateGroup : handleCreateGroup}
              >
                {isGroupEdit ? "Update" : " Create"}
              </Button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Messages;
